import { render, staticRenderFns } from "./DataCalculatorSettings.vue?vue&type=template&id=74d795e4&"
import script from "./DataCalculatorSettings.vue?vue&type=script&lang=js&"
export * from "./DataCalculatorSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports